import { render, staticRenderFns } from "./ReturnPolicy.vue?vue&type=template&id=41301c9a"
import script from "./ReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ReturnPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports